// extracted by mini-css-extract-plugin
export default {"outer":"FormTemplateManagement_outer__XJfis","filter":"FormTemplateManagement_filter__lMiL0"};